import request from "./http";
import {
  AUTH_ENDPOINT,
  AUTH_ENDPOINT_GET_ALL_SESSIONS,
  AUTH_ENDPOINT_LOGIN,
  AUTH_ENDPOINT_LOGOUT,
  AUTH_ENDPOINT_REFRESH_TOKEN,
  AUTH_ENDPOINT_SESSION_CLOSE,
  AUTH_ENDPOINT_SESSION_CLOSE_ALL,
  AUTH_V2_ENDPOINT_LOGIN,
  AUTH_V2_VERIFICATION_ENDPOINT_LOGIN,
} from "../infrastructure/appConstants";
import { setToken, removeToken, getDateTimeToken } from "../config/auth/credentialConfiguration";
import { decryptJsonValuesRecursive } from "../util/cryptoUtils";

const authService = {
  login: async (credentials) => {
    try {
      const response = await request.post(AUTH_ENDPOINT_LOGIN, credentials);
      if (response) {
        setToken(response.data.token, response.data.refreshToken);
      }
      return response;
    } catch (error) {
      throw error;
    }
  },
  loginV2: async (credentials) => {
    try {
      return await request.post(AUTH_V2_ENDPOINT_LOGIN, credentials);
    } catch (error) {
      throw error;
    }
  },
  loginVerificationV2: async (req) => {
    try {
      let response = await request.post(AUTH_V2_VERIFICATION_ENDPOINT_LOGIN, req);
      response = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
      if (response) setToken(response.data.token, response.data.refreshToken);
      if (response) getDateTimeToken();
      return response;
    } catch (error) {
      throw error;
    }
  },
  refreshToken: async (req) => {
    try {
      const response = await request.post(AUTH_ENDPOINT_REFRESH_TOKEN, req);
      if (response) {
        setToken(response.data.token, response.data.refreshToken);
        getDateTimeToken();
      }
      return response;
    } catch (error) {
      throw error;
    }
  },
  registerIdentification: async (data) => {
    try {
      const response = await request.post(
        `${AUTH_ENDPOINT}/register/identification`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  registerValidation: async (data) => {
    try {
      const response = await request.post(
        `${AUTH_ENDPOINT}/register/validation`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  sendVerification: async (data) => {
    try {
      const response = await request.post(
        `${AUTH_ENDPOINT}/verification`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  registerConfirmation: async (data) => {
    try {
      const response = await request.post(
        `${AUTH_ENDPOINT}/register/confirmation`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  currentUser: async () => {
    try {
      const response = await request.get(`${AUTH_ENDPOINT}/auth/user`);
      const decryptedData = await decryptJsonValuesRecursive(response, process.env.REACT_APP_KEY);
      return decryptedData;
    } catch (error) {
      throw error;
    }
  },
  logout: async () => {
    try {
      await request.post(AUTH_ENDPOINT_LOGOUT);
      removeToken();
    } catch (error) {
      throw error;
    }
  },
  recoverValidation: async (data) => {
    try {
      const response = await request.post(
        `${AUTH_ENDPOINT}/recover/validation`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  recoverConfirmation: async (data) => {
    try {
      const response = await request.post(
        `${AUTH_ENDPOINT}/recover/confirmation`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  closeSession: async (data) => {
    try {
      await request.post(AUTH_ENDPOINT_SESSION_CLOSE, data);
    } catch (error) {
      throw error;
    }
  },
  closeAllSessions: async (data) => {
    try {
      await request.post(AUTH_ENDPOINT_SESSION_CLOSE_ALL, data);
    } catch (error) {
      throw error;
    }
  },
  getAllSessions: async () => {
    try {
      const response = await request.post(AUTH_ENDPOINT_GET_ALL_SESSIONS);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default authService;
